"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_select_1 = __importStar(require("react-select"));
require("./style.sass");
function SingleValue(props) {
    return (react_1.default.createElement(react_select_1.components.SingleValue, __assign({}, props), props.children));
}
var customStyle = {
    valueContainer: function (base) { return (__assign(__assign({}, base), { display: 'flex', flexDirection: 'row' })); },
};
var DropDown = function (_a) {
    var options = _a.options, onChange = _a.onChange, placeholder = _a.placeholder, disabled = _a.disabled, icon = _a.icon, label = _a.label, value = _a.value, error = _a.error, mainStyle = _a.mainStyle, isMulti = _a.isMulti, InputLabelStyle = _a.InputLabelStyle;
    function ValueContainer(props) {
        return (react_1.default.createElement(react_select_1.components.ValueContainer, __assign({}, props, { style: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row !important',
            } }),
            react_1.default.createElement("div", { style: { display: 'flex', alignSelf: 'center' } },
                " ",
                icon),
            react_1.default.createElement("div", { style: { display: 'flex', flex: 1 } }, props.children)));
    }
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { style: mainStyle
            ? {
                margin: '0.31rem 0',
                display: 'flex',
                flexDirection: 'column',
            }
            : {
                margin: '0.31rem 0',
                display: 'flex',
                flex: 1,
                width: '100%',
                flexDirection: 'column',
            } },
        error && react_1.default.createElement("p", { className: 'error' }, t(error)),
        label ? (react_1.default.createElement("div", { className: 'input-label', style: InputLabelStyle },
            react_1.default.createElement("label", { className: 'label' }, label),
            react_1.default.createElement("div", { className: 'select-control-no-shadow' },
                react_1.default.createElement(react_select_1.default, { value: isMulti
                        ? value
                        : value !== null && options
                            ? options.find(function (option) {
                                return option.value.toString() === value;
                            })
                            : value, isMulti: isMulti, onChange: onChange, options: options ? options : [], backspaceRemovesValue: false, menuPlacement: 'auto', className: 'input-no-shadow', 
                    // icon={icon}
                    components: { SingleValue: SingleValue, ValueContainer: ValueContainer }, placeholder: placeholder, styles: customStyle, theme: function (theme) { return (__assign(__assign({}, theme), { borderRadius: 5, colors: __assign(__assign({}, theme.colors), { text: '#121212', primary25: '#E4E6E8', primary: '#883D20' }) })); } })))) : (react_1.default.createElement("div", { className: 'select-control-no-shadow', style: mainStyle ? { width: '15vw' } : { width: '100%' } },
            react_1.default.createElement(react_select_1.default, { isDisabled: disabled, value: isMulti
                    ? value
                    : value !== null && options
                        ? options.find(function (option) { return option.value === value; })
                        : value, isMulti: isMulti, onChange: onChange, options: options, 
                // icon={icon}
                backspaceRemovesValue: false, className: 'select-no-shadow', styles: customStyle, components: {
                    SingleValue: SingleValue,
                    ValueContainer: ValueContainer,
                }, theme: function (theme) { return (__assign(__assign({}, theme), { borderRadius: 5, colors: __assign(__assign({}, theme.colors), { text: '#121212', primary25: '#E4E6E8', primary: '#883D20' }) })); } })))));
};
exports.default = DropDown;
